import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, Modal, Radio, Cascader, Select} from 'antd';
import SPSelectWithApi from "../../../../product-price/base/SPSelectWithApi";
import request from "../../../../../request";
import {_APIS} from "../../../../../apis";


interface IComponentProps {
  isAllStore?: any
  isAllModel?: any
  enums: any
}


const ChooseCarModelByStore: React.FC<IComponentProps> = (props) => {
  const [isAllModelFlag, setIsAllModelFlag] = useState(null)
  const [isAllStoreFlag, setIsAllStoreFlag] = useState(null)
  const [allModelList, setAllModelList] = useState<any[]>([])
  const [selectModelOption, setSelectModelOption] = useState<any[]>([])
  const curModelMapRef = useRef<any>({});
  const form = Form.useFormInstance();
  const [options, setOptions] = useState<any[]>([]);

  
  useEffect(() => {
    setIsAllStoreFlag(form?.getFieldValue(['act_reg_store_status']))
    setIsAllModelFlag(form?.getFieldValue(['act_reg_price_mod_status']))
  }, []);

  const onChangeStoreSelectType = (e: any) => {
    setIsAllStoreFlag(e.target.value)
    const city_store_list = form.getFieldValue('city_store_list')
    onStoreChange(city_store_list, allModelList, e.target.value === 0 ? true : false)
  }

  const onChangeModelSelectType = (e: any) => {
    setIsAllModelFlag(e.target.value)
  }

  // 集合车型
  const getModelsObj = (list: any[]) => {
    const obj: any = {}
    list.forEach((item: any) => {
      const name = `${item.veh_brand_name} · ${item.veh_series_name} · ${item.veh_model_name}`
      if (obj[name]) {
        obj[name].push(item.price_mod_code)
      } else {
        obj[name] = [item.price_mod_code]
      }
    })
    return obj
  }

  // 生成车型拉框选项
  const getSelectOptionList = (obj: any) => {
     return  Object.keys(obj).map((item: any) => {
        return {
          value: item,
          name: item,
        }
      })
  }

  const getAllModels = async () => {
    const params = {
      "page": 1,
      "page_size": 100000,
      "veh_num_type": -1,
      "veh_num": "",
      "status": -1
    }
    const res = await request.post(_APIS.PRODUCT_PRICE.CAR_MODEL_PRICE.PRICE_LIST_ALL,  params);
    const data = res?.data || [];
    setAllModelList(data);
    return data;
  }


  // 根据storeList和allmodellist生成选项map curModelMapRef.current  和 车型选择 selectModelOption
  const getSelectInit = (list: any, storeList?: any) => {
    console.log(list,storeList, 999)
    if (storeList) {
      list = list.filter((item: any) => {
        return storeList?.includes(item.store_code)
      })
    }
    const obj = getModelsObj(list)
    console.log(obj, '===')
    curModelMapRef.current = obj
    const listRes: any = getSelectOptionList(obj)
    setSelectModelOption(listRes)
    return listRes
  }

  // 首次初始化
  const initSelectedModelByPriceId = (allList: any) => {
    const list = form.getFieldValue('price_mod_code_list')
    const act_reg_price_mod_status = form.getFieldValue('act_reg_price_mod_status')
    if (list?.length && act_reg_price_mod_status === 1) {
      console.log(list, 11);
      const arr = allList?.filter((item: any) => list?.includes(item.price_mod_code))
      console.log(arr, 22);
      const modeArr = [...new Set(arr.map((item: any) =>  `${item.veh_brand_name} · ${item.veh_series_name} · ${item.veh_model_name}`))]
      console.log(modeArr, 33);
      form.setFieldsValue({
        dddd: modeArr
      })
    }
    if (form.getFieldValue('city_store_list')?.length && form?.getFieldValue(['act_reg_store_status']) === 1) {
      onStoreChange(form.getFieldValue('city_store_list'), allList)
    }
    if (form?.getFieldValue(['act_reg_store_status']) === 0) {
      onStoreChange(form.getFieldValue('city_store_list'), allList, true)
    }
  }

  const init = async () => {
    const res = await getAllModels()
    initSelectedModelByPriceId(res)
  }

  const initGetStoreList = async () => {
    const res = await request.get(_APIS.ACTIVES.TAKE_THE_LEAD.STORE_LIST_BY_CITY,  {})
    setOptions(res?.data || [])
  }

  useEffect(() => {
    init()
    initGetStoreList()
  }, []);

  const onPriceListChangeByModel = (e: any) => {
    let arr: any = []
    e?.forEach((item: any) => {
      arr = [...arr, ...(curModelMapRef.current?.[item] || [])]
    })
    console.log(arr, 888);
    form.setFieldsValue(
      {
        price_mod_code_list: arr
      }
    )
  }
  // isAll是不是全部门店  allModelList永远是所有车型 isAll是不是选择了全部门店
  const onStoreChange = (e: any, allModelList: any, isAll: boolean = false) => {
    console.log(e, allModelList, 555)
    // 生成下拉选择项,
    getSelectInit(allModelList, !isAll ? e?.map((item: any) => item?.[1]) : undefined)
    const dddd = form.getFieldValue('dddd') || []
    console.log(dddd, 666);
    const arr = dddd?.filter((item: any) => !!curModelMapRef.current?.[item])
    console.log(arr, 777);
    // 更新聚合的车型
    form.setFieldsValue({
      dddd: arr,
    })
    onPriceListChangeByModel(arr) // 更新提交的price_list
  }


  return (
    <>
      <Form.Item label='参与门店'>
        <Form.Item noStyle name='act_reg_store_status' rules={[
          {
            required: true,
            message: '请选择'
          }
        ]}>
          <Radio.Group  onChange={onChangeStoreSelectType}>
            <Radio value={0}>全部门店</Radio>
            <Radio value={1}>部分门店</Radio>
          </Radio.Group>
        </Form.Item>
        {
          isAllStoreFlag === 1 ?
            <Form.Item noStyle name='city_store_list' rules={[
              {
                required: true,
                message: '请选择'
              }
            ]}>
              <Cascader
                showSearch
                style={{marginTop: '10px' }}
                multiple
                fieldNames={{ label: 'name', value: 'code', }}
                showCheckedStrategy={Cascader.SHOW_CHILD}
                options={options}
                onChange={(e) => {
                  console.log(e, 'ee');
                  onStoreChange(e, allModelList)
                }}
                placeholder="请选择" />
            </Form.Item>
            : null
        }
      </Form.Item>
      <Form.Item label='参与车型' >
        <Form.Item noStyle name='act_reg_price_mod_status' rules={[
          {
            required: true,
            message: '请选择'
          }
        ]}>
          <Radio.Group onChange={onChangeModelSelectType}>
            <Radio value={0}>全部车型</Radio>
            <Radio value={1}>部分车型</Radio>
          </Radio.Group>
        </Form.Item>
        {
          isAllModelFlag === 1 ?
            <Form.Item name='dddd' noStyle  rules={[
              {
                required: true,
                message: '请选择'
              }
            ]}>
              <Select
                showSearch
                filterOption={(input:any, option: any) => (option?.value ?? '').includes(input)}
                mode="multiple"
                fieldNames={{ label: 'name', value: 'value' }}
                style={{marginTop: '10px'  }}
                options={selectModelOption}
                onChange={onPriceListChangeByModel}
              />
            </Form.Item>
            : null
        }
      </Form.Item>
      {
        isAllModelFlag === 1 ?
          <Form.Item noStyle name='price_mod_code_list'>

          </Form.Item> : null
      }
    </>
  );
};

export default ChooseCarModelByStore;
